import { bridge } from '../../../bridge';
import { isNotNil } from '../../../isNotNil';
import {
  appendParams,
  finalizeUrl,
  getDefaultWebviewLink,
} from '../../utils';

export const moveToPhotoReviewList = (params: {
  goodsSno: number;
  reviewSno?: number;
  titleBar?: boolean;
}) => {
  const pagePath = `/goods/${params.goodsSno}/reviews/photo/list${isNotNil(params.reviewSno) ? `?review_sno=${params.reviewSno}` : ''}`;

  const link = getDefaultWebviewLink(params.titleBar ?? false);
  appendParams(link, 'url', pagePath);
  bridge.openDeeplink(finalizeUrl(link));
};
